'use strict';

import videoCarousel from './blocks/videoCarsouel.js';
import resourceFilterForm from './form/resource-filter-form';
import ratingModal from './blocks/ratingModal';

window.addEventListener('DOMContentLoaded', function () {
  videoCarousel.init();
  resourceFilterForm.init();
  ratingModal.init();
});
